<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div fxLayout="column" id="itemRecordContainer">
  <record-text [text]="record.hintText"></record-text>
  <record-icon-text [text]="getText()" [icon]="faImages"></record-icon-text>
  <div *ngIf="record.images" id="recordImageContainer">
    <record-image [images]="record.images"></record-image>
  </div>
</div>
